import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import mixins from '../mixins.js'
import { VAT_EX } from '../../const/common.js'
import servingMixins from '../mixins/serving-mixins'
import SimpleSingleselect from '../../component/singleselect.vue'
import SimpleNumberInput from '../../component/simple-form/numberInput.vue'
import multimedia from '../../component/dccore-form/multimedia.vue'
import Checkbox from '../../component/simple-form/checkbox.vue'

if ($('#serving_final_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#serving_final_form',
    components: {
      TextInput,
      Singleselect,
      Multiselect,
      RingLoader,
      NumberInput,
      SimpleSingleselect,
      SimpleNumberInput,
      multimedia,
      Checkbox
    },
    mixins: [mixins, servingMixins],
    data: {
      loading: 0,
      multimedia: [],
      entityId: null,
      hasAllComponentServings: true,
      form: {
        entity: {
          servingGrammages: [],
          selectedServingPackages: {},
          sizes: [],
          expireDay: 2,
          type: 'final',
          meal: null,
          vatRate: null,
        },
        options: {
          errors: {
            servingPackages:[]
          },
          packages: [],
          units: [],
          meals: [],
          sizes: [],
          packagingTechnologies: [],
        }
      },
      servingPackages : {},
      brands: null,
      portions: [],
      componentMeals: [],
      selectedPackages: {},
      rowsIngredients: 0,
      amountIngredients: 0,
      ingredients: [],
      sumWeight: 0,
      specialPackageTypes: [],
      quantityServingGrammages : {},
      ingredients100g: [],
      flatservingIngredients: [],
      flatservingIngredients100g: [],
      correctCalorificKcal: false,
      flatservingCorrectCalorificKcal: false,
      flatservingAmountIngredients: 0,
      flatservingRowsIngredients: 0,
      blockingFieldEditing: false,
      blockingFieldsEditingBySourceD365: false,
    },
    watch: {
      'form.entity.meal': function (val) {
        if (val > 0) {
          if (!this.entityId) {
            this.form.entity.servingGrammages = []
          }
          this.getServingGrammages(!this.entityId)
          this.getBrands(!this.entityId)
          this.calculateWeight()
        }
      }
    },
    mounted() {

      this.getPackagingTechnology()
      this.getPackages()
      this.getSpecialPackageTypes()
      this.getUnits()

      this.getSizes()
      this.getVatRates()

      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getServing()
      } else {
        this.getFinalMeals()
      }
    },
    methods: {
      shouldBeDisabled(brandId, index) {
        const servingPackage = this.servingPackages[brandId].packages[index]
        const object = this.form.options.packages.find(element => element.id === servingPackage.package)
        if (object) {
          const disabled = this.specialPackageTypes.includes(object.type)
          if (disabled) {
            servingPackage.sticker = false
            servingPackage.packageTechnology = null
            this.servingPackages[brandId].packages[index] = servingPackage

            return true
          }
        }
        return false
      },
      getSpecialPackageTypes() {
        let url = Routing.generate('api_get_special_package_types')
        this.loading++
        Vue.http.get(url).then(response => {
          this.specialPackageTypes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      createServing(redirect) {
        if (!this.hasAllComponentServings) {
          toastr.error(Translator.trans('serving.errors.not_fill_component_meals'))
          return
        }

        if (this.checkDuplicateServing()) {
          toastr.error(Translator.trans('serving.errors.duplicate_serving'))
          return
        }

        if (!this.$refs.errorChecker.errorCheck()) {
          this.prepareServingPackageToSend()
          let url = Routing.generate('api_post_serving_final')
          let data = {
            data: this.form.entity,
            multimedia: this.multimedia
          }

          this.loading++
          this.$http.post(url, data).then(() => {
            this.errors = { servingPackages: [] }
            if (redirect) {
              $(location).attr('href', Routing.generate('serving_grid'))
            } else {
              toastr.success(Translator.trans('form.created'))
            }
            this.loading--

          }, response => {
            this.loading--
            this.handleAjaxError(response, this.form.options)
          })
        }
      },
      updateServing(redirect) {
        if (this.checkDuplicateServing()) {
          toastr.error(Translator.trans('serving.errors.duplicate_serving'))
          return
        }

        if (!this.$refs.errorChecker.errorCheck()) {
          this.loading++
          let url = Routing.generate('api_patch_serving_final', {
            id: this.entityId,
          })

          this.prepareServingPackageToSend()
          let data = {
            data: this.form.entity,
            multimedia: this.multimedia
          }

          this.$http.patch(url, data).then(() => {
            if (redirect) {
              $(location).attr('href', Routing.generate('serving_grid'))
              this.loading--
            } else {
              this.refreshPrice(this.entityId).then(() => {
                toastr.success(Translator.trans('form.updated'))
                this.form.options.errors = {
                  servingPackages: []
                }
                this.loading--
              })
            }
          }, response => {
            this.loading--
            this.handleAjaxError(response, this.form.options)
          })
        }
      },
      getServing() {
        this.loading++
        let url = Routing.generate('api_get_serving', { id: this.entityId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.form.entity = response.data.serving
          this.form.entity.meal = response.data.serving.selectedMeal
          this.form.entity.servingGrammages = response.data.serving.selectedServingGrammages
          this.form.entity.sizes = response.data.serving.selectedSizes
          this.servingPackages = response.data.serving.selectedServingPackages
          this.form.entity.vatRate = response.data.serving.VatRateTagId
          if (this.form.entity.multimedia) {
            this.multimedia = this.form.entity.multimedia.collection

            delete this.form.entity.multimedia
          }

          this.calculateIngredients()
          this.getNutritionalValueFromFlatServing()
          this.blockingFieldEditing = response.data.blockingFieldEditing
          this.blockingFieldsEditingBySourceD365 = response.data.blockingFieldsEditingBySourceD365
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getUnits() {
        let url = Routing.generate('api_get_materials_units')
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.units = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getSizes() {
        let url = Routing.generate('api_get_sizes', { context: 'dropdown' })
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.sizes = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getVatRates() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'VAT_RATE',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          response.data.forEach((rate) => {
            rate.label = rate.systemValue !== VAT_EX ? `${rate.value}%` : rate.value
          })
          this.form.options.vatRates = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getFinalMeals() {
        this.loading++
        let url = Routing.generate('api_get_meals_final', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.meals = response.data

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      calculateIngredients() {
        let data = { data: this.form.entity }
        let url = Routing.generate('api_post_serving_calculate_ingredients')
        this.$http.post(url, data).then(response => {

          this.ingredients = response.data.ingridients
          this.correctCalorificKcal = response.data.correctCalorificKcal

          this.ingredients100g = response.data.ingridients100g

          this.rowsIngredients = Math.floor(this.ingredients.length / 3)
          this.amountIngredients = this.ingredients.length
          this.form.options.errors = {
            servingPackages:[]
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
          toastr.error(Translator.trans('form.errors.fill_all_fields'))
        })
      },
      getServingGrammages(updateServingGrammages) {
        this.loading++
        let url = Routing.generate('api_get_meals_component_meals', {
          id: this.form.entity.meal,
          context: 'serving'
        })
        this.$http.get(url).then(response => {
          this.componentMeals = response.data
          if (updateServingGrammages) {
            for (let i = 0; i < this.componentMeals.length; i++) {

              if (this.componentMeals[i].componentServings.length === 0) {
                this.form.options.errors = {
                  'meal': { 1: Translator.trans('serving.errors.not_fill_component_meals') },
                  'servingPackages' : [],
                }
                this.hasAllComponentServings = false
                this.form.entity.servingGrammages = []
                this.loading--
                return
              }

              const selectedComponentServing = this.componentMeals[i].componentServings.length > 0 ?
                this.componentMeals[i].componentServings[0].id : null
              const selectedUnit = this.componentMeals[i].componentServings.length > 0 ?
                this.componentMeals[i].componentServings[0].unit : ''
              const selectedWeight = this.componentMeals[i].componentServings.length > 0 ?
                this.componentMeals[i].componentServings[0].weight : 0

              this.form.entity.servingGrammages.push( {
                'componentServing' : selectedComponentServing,
                'selectedComponentServing':  selectedComponentServing,
                'unit': selectedUnit,
                'weight' : selectedWeight,
                'servings' : this.componentMeals[i].componentServings,
                'type': 'component_meal',
                'value' : 0,
                'meal' : this.componentMeals[i].id,
              })

            }

            this.form.options.errors = {
              servingPackages:[]
            }
            this.hasAllComponentServings = true
          }
          this.calculateQuantityCheckedMeals()
          this.getPortions(!this.entityId)
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getBrands(updateServingPackages) {
        this.loading++
        let url = Routing.generate('api_get_meals_brands_for_meal', {
          id: this.form.entity.meal,
          context: 'dropdown'
        })
        this.$http.get(url).then(response => {
          this.brands = response.data
          if (updateServingPackages) {
            this.servingPackages = {}
            for (let i = 0; i < this.brands.length; i++) {
              this.servingPackages[this.brands[i].id] = {
                brandName: this.brands[i].name,
                packages : [],
              }
            }
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },

      getPackages() {
        this.loading++
        let url = Routing.generate('api_get_materials_packages', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.packages = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getPackagingTechnology() {
        this.loading++
        let url = Routing.generate('api_get_tags', { 'type': 'packaging_technology',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.form.options.packagingTechnologies = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getServingComponentNameById(id) {
        for (let i = 0; i < this.componentMeals.length; i++) {
          if (this.componentMeals[i].componentServingId === id) {
            return this.componentMeals[i].name
          }
        }
      },
      translateIngredient(name) {
        return Translator.trans(`ingredient.entity.${name}`)
      },
      getBrandNameById(id) {
        for (let i = 0; i < this.brands.length; i++) {
          if (this.brands[i].id === id) {
            return this.brands[i].name
          }
        }
      },
      addNewServingPackage(brandId) {
        this.servingPackages[brandId].packages.push(
          {
            'brand' : brandId,
            'packageTechnology' : null,
            'sticker' : false,
          })

        this.$forceUpdate()
      },
      removeServingPackage(brandId, index) {
        this.servingPackages[brandId].packages.splice(index, 1)
        this.$forceUpdate()
      },
      prepareServingPackageToSend() {
        let servingPackages = []
        Object.values(this.servingPackages).forEach((servingPackage) => {
          servingPackages = servingPackages.concat(Object.values(servingPackage.packages))
        })
        this.form.entity.servingPackages = servingPackages
        return servingPackages
      },
      clearServingPackageErrors(index) {
        if (this.form.options.errors.servingPackages && this.form.options.errors.servingPackages[index]) {
          this.form.options.errors.servingPackages[index] = {}
        }
      },
      getNutritionalValueFromFlatServing () {
        let url = Routing.generate('api_get_serving', { id: this.entityId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.flatservingIngredients = response.data.serving.nutritionalValue
          this.flatservingIngredients100g = response.data.serving.nutritionalValue100g
          this.flatservingAmountIngredients = this.flatservingIngredients ? this.flatservingIngredients.length : 0
          this.flatservingRowsIngredients = this.flatservingIngredients ? Math.floor(this.flatservingIngredients.length / 3) : 0
          this.flatservingCorrectCalorificKcal = response.data.serving.isCorrectCalorificCalculate
        }, response => {
          this.handleAjaxError(response, this.form.options)
          toastr.error(Translator.trans('form.errors.fill_all_fields'))
        })
      },
    }
  })
}
